import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListUnordered = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4 7C4.55228 7 5 6.55228 5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7ZM8.75 5.5C8.33579 5.5 8 5.83579 8 6.25C8 6.66421 8.33579 7 8.75 7H20.25C20.6642 7 21 6.66421 21 6.25C21 5.83579 20.6642 5.5 20.25 5.5H8.75ZM8.75 11.5C8.33579 11.5 8 11.8358 8 12.25C8 12.6642 8.33579 13 8.75 13H20.25C20.6642 13 21 12.6642 21 12.25C21 11.8358 20.6642 11.5 20.25 11.5H8.75ZM8.75 17.5C8.33579 17.5 8 17.8358 8 18.25C8 18.6642 8.33579 19 8.75 19H20.25C20.6642 19 21 18.6642 21 18.25C21 17.8358 20.6642 17.5 20.25 17.5H8.75ZM5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM4 19C4.55228 19 5 18.5523 5 18C5 17.4477 4.55228 17 4 17C3.44772 17 3 17.4477 3 18C3 18.5523 3.44772 19 4 19Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgListUnordered;
